import { useState, useEffect, useRef } from "react";
import Sidebar from "../components/SidebarUpdate";
import { useParams, useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { IoIosHeart } from "react-icons/io";
import apiInstance from "../apiConfig/apiinstance";
import { showNotification } from "../apiConfig/notification";
import DummyImage from "../assest/images/dummy_image.jpg";
import LoginModal from "../components/LoginModal";

const ProductDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [tempData, setTempData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showHeart, setShowHeart] = useState(false);
  const [liked, setLiked] = useState(false);
  const tapTimeout = useRef(null);
  const [loginModalShow, setLoginModalShow] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    const token = localStorage.getItem("token");
    try {
      const { data } = await apiInstance.get(
        `/api/style/v1/style-details/${id}`,
        token && {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (data.status === 200) {
        setTempData(data.data);
      }
      setLoading(false);
    } catch (error) {
      setError(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [id]);

  // Like (wishlist) handler
  const postData = async (likeValue) => {
    setLoading(true);
    setError(null);

    const token = localStorage.getItem("token");

    if (token) {
      try {
        const { data } = await apiInstance.post(
          `/api/style/v1/likes/`,
          {
            style: id,
            is_liked: likeValue,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (data.status === 201) {
          showNotification(
            "Wishlist",
            likeValue
              ? "Style Added to wishlist"
              : "Style Removed from wishlist",
            "success"
          );
        }
      } catch (error) {
        //jai maa kali
        if (error?.status === 401) {
          showNotification(
            "Authentication",
            "Session expired. Please login again.",
            "danger"
          );

          setLoginModalShow(true);
        } else {
          setError(error?.response?.data?.message || "Error updating wishlist");
        }
      } finally {
        setLoading(false);
      }
    } else {
      showNotification(
        "Wishlist",
        likeValue
          ? "Added wishlist Fail First Login After Then Added to wishlist"
          : "Remove wishlist Fail First Login After Then Remove to wishlist",
        "danger"
      );
      // setTimeout(() => {
      //   window.location.href = "/login";
      // }, 1500);
      setLoginModalShow(true);
    }
  };

  // Double tap handler
  const handleDoubleTap = async () => {
    if (tapTimeout.current) {
      clearTimeout(tapTimeout.current);
      tapTimeout.current = null;
      setShowHeart(true);
      const newLiked = !liked;
      setLiked(newLiked);
      await postData(newLiked);
      await fetchData();
      setTimeout(() => setShowHeart(false), 1000);
    } else {
      tapTimeout.current = setTimeout(() => {
        tapTimeout.current = null;
      }, 300);
    }
  };

  const handleBackNavigation = () => {
    try {
      // Try to get the stored navigation state
      const storedState = sessionStorage.getItem("lastNavigationState");

      if (storedState) {
        const navigationState = JSON.parse(storedState);

        // Construct the full URL with the stored state
        const fullPath = `${navigationState.pathname}${navigationState.search}`;

        // Navigate to the stored location
        navigate(fullPath);

        // Clean up the stored state
        sessionStorage.removeItem("lastNavigationState");
      } else {
        // Fallback: try browser back button first
        if (window.history.length > 1) {
          navigate(-1);
        } else {
          // Last resort: go to home page
          navigate("/");
        }
      }
    } catch (error) {
      console.error("Error in back navigation:", error);
      // Fallback to home page
      navigate("/");
    }
  };

  useEffect(() => {
    if (tempData) {
      setLiked(tempData?.like);
    }
  }, [tempData]);

  console.log("tempdata", tempData);

  const styleCoverImageId = tempData?.cover_photo_id;

  return (
    <div className="parent_Container">
      {error ? (
        <h2 style={{ color: "red", textAlign: "center" }}>{error}</h2>
      ) : (
        <div className="content_wrapper py-4 px-4 md:px-8">
          <Sidebar logo="FP ONE" />

          <div className="content_wrapper_child md:ml-[18rem] mt-[5rem] md:mt-0">
            <button onClick={handleBackNavigation} className="mb-5">
              &larr; Back
            </button>
            <div className="product_detail">
              <div className="image_description_container">
                <div className="image_container_detail">
                  {loading ? (
                    <div className="loader-container">
                      <ClipLoader color="#3498db" loading={loading} size={50} />
                    </div>
                  ) : (
                    <>
                      <LoginModal
                        show={loginModalShow}
                        onHide={() => setLoginModalShow(false)}
                      />
                      <div
                        className="product-parent-heart"
                        onClick={handleDoubleTap}
                      >
                        {/* Big Heart Effect */}
                        {showHeart && <IoIosHeart className="heart-effect" />}
                        {/* Small Heart in Corner */}
                        <IoIosHeart
                          className={`heart-icon ${liked ? "liked" : ""}`}
                        />
                        <div className="image-wrapper relative">
                          <img
                            src={
                              tempData?.cover_photo ||
                              tempData?.photos?.[0]?.url ||
                              DummyImage
                            }
                            alt="Selected Product"
                            className="large_image"
                          />

                          {/* Show "Image not found" text when DummyImage is displayed */}
                          {!tempData?.cover_photo &&
                            !tempData?.photos?.[0]?.url && (
                              <div className="image-not-found-overlay">
                                <span className="image-not-found-text">
                                  Image not found
                                </span>
                              </div>
                            )}
                        </div>

                        {
                          <IoIosHeart
                            className={`heart-size ${liked ? "liked" : ""}`}
                            onClick={handleDoubleTap}
                          />
                        }
                      </div>
                    </>
                  )}
                </div>

                <div className="product_details_container">
                  <h1 className="text-2xl md:text-3xl lg:text-4xl">
                    {tempData?.style_name}
                  </h1>
                </div>
              </div>
            </div>

            <div className="product_container">
              {tempData?.photos
                ?.filter((img) => img.image_id !== styleCoverImageId)
                .map((product) => (
                  <div className="cart-detail" key={product.image_id}>
                    <div className="image_container">
                      <img src={product.url} alt={product.name || "Product"} />
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductDetail;
